'use client';

import { useAtomValue } from 'jotai';
import { pdpParamsWithSyncAtom } from '@/atoms/pdpParamsAtom';
import { useImageBaseUrl } from '@/atoms/processEnvAtom';
import { useResolvedAppearances } from '@/components/ProductCard/AppearanceConfigProvider';
import { SprdResponsiveImage } from '@/components/ResponsiveImage/SprdResponsiveImage';
import { getProductTypeImageAltText } from '@/utility/seo';

type ProductInfoImage = {
  productType: ClientProductType;
};

export const ProductInfoImage = ({ productType }: ProductInfoImage) => {
  const pdpParams = useAtomValue(pdpParamsWithSyncAtom);
  const imageBaseUrl = useImageBaseUrl();
  const appearanceId = pdpParams?.appearanceId;
  const [appearance] = useResolvedAppearances(appearanceId ? [appearanceId] : []);
  if (!appearanceId) return;

  const hasMaterialView = productType.views.find((view) => view.id === '12');

  return (
    <div className="flex flex-nowrap justify-center gap-4 overflow-hidden">
      <SprdResponsiveImage
        className={hasMaterialView ? 'w-1/2 bg-[#f2f2f2]' : 'bg-[#f2f2f2]'}
        imageBaseUrl={imageBaseUrl}
        image={{
          type: 'productType',
          productTypeId: productType.id,
          viewId: productType.defaultValues.defaultView.id,
          appearanceId,
          backgroundColor: '#F2F2F2',
          alt: getProductTypeImageAltText(
            productType.name,
            appearance?.name ?? '',
            productType.views.find((v) => v.id === productType.defaultValues.defaultView.id)?.name
          ),
          loading: 'lazy',
          priority: 'low',
        }}
      />
      {hasMaterialView && (
        <SprdResponsiveImage
          className="w-1/2"
          imageBaseUrl={imageBaseUrl}
          image={{
            type: 'productType',
            productTypeId: productType.id,
            viewId: '12',
            appearanceId,
            alt: productType.name,
            loading: 'lazy',
            priority: 'low',
          }}
        />
      )}
    </div>
  );
};
